import { Box, Image, Tooltip, keyframes } from '@chakra-ui/react'
import { formatPrice } from '../../../utils/formatPrice'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter'
import { useRef, useEffect } from 'react'

export function Card({ item }) {
  const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
    
    
    //from {
    //  transform: scale(0.5);
    //  opacity: 0;
    //} 
    //to {
    //    transform: scale(1);
    //    opacity: 1;
    //}
    `

  return (
    <Tooltip
      maxW="600px"
      w={'275px'}
      label={item.dados_cores?.map((item) => {
        if (parseInt(item.quantity) > 0) {
          return (
            <Box
              key={item.id}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box as="span" fontSize="sm">
                {item.name}
              </Box>
              <Box as="span" fontWeight="bold" fontSize="sm">
                {item.quantity}
              </Box>
            </Box>
          )
        } else {
          ;<></>
        }
      })}
      aria-label="A tooltip"
    >
      <Box
        key={item.id}
        bg="white"
        borderRadius="md"
        mb="4"
        overflow={'hidden'}
        animation={`${fadeIn} 0.5s ease-in-out`}
        cursor="pointer"
      >
        <Box w="170px" h={'210px'} overflow="hidden" m={'auto'}>
          <Image
            src={item.image_prod}
            alt={item.name}
            w="100%"
            h="100%"
            objectFit="cover"
          />
        </Box>
        <Box p={4}>
          <Box as="span" fontWeight="bold" fontSize="md">
            {firstLetterUpperCaseAndRestLowerCase(item.name)}
            {/*Nome*/}
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box as="span" fontSize="sm">
              Código do produto
            </Box>
            <Box as="span" fontWeight="bold" fontSize="sm">
              {item.codigo_produto}
            </Box>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            cursor="pointer"
          >
            <Box as="span" fontSize="sm">
              Cores em estoque
            </Box>
            <Box as="span" fontWeight="bold" fontSize="sm">
              {
                item.dados_cores?.filter((item) => parseInt(item.quantity) > 0)
                  .length
              }
            </Box>
          </Box>
        </Box>
      </Box>
    </Tooltip>
  )
}
